import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, FileText, PhoneCall } from "lucide-react";
import { COMPANY, SERVICES } from "../lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-vegetal-800 text-vegetal-100/80 mt-24">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="grid place-items-center h-10 w-10 rounded-md bg-terracotta-500 text-white font-heading font-extrabold text-lg">C</span>
              <span className="leading-tight">
                <span className="block font-heading font-bold text-[15px] text-white">Carnier</span>
                <span className="block text-[11px] uppercase tracking-[0.18em] text-vegetal-200">Toiture & Habitat</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-vegetal-100/70">
              Artisan spécialiste de la toiture et de l'amélioration de l'habitat dans l'Oise. Rénovation, entretien et protection durable de votre maison.
            </p>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Prestations</h4>
            <ul className="space-y-2 text-sm">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link to={`/prestations#${s.slug}`} className="hover:text-terracotta-300 transition-colors">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/realisations" className="hover:text-terracotta-300 transition-colors">Réalisations</Link></li>
              <li><Link to="/a-propos" className="hover:text-terracotta-300 transition-colors">À propos</Link></li>
              <li><Link to="/zone-intervention" className="hover:text-terracotta-300 transition-colors">Zone d'intervention</Link></li>
              <li><Link to="/faq" className="hover:text-terracotta-300 transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-terracotta-300 transition-colors">Contact</Link></li>
              <li><Link to="/mentions-legales" className="hover:text-terracotta-300 transition-colors">Mentions légales</Link></li>
              <li><Link to="/politique-confidentialite" className="hover:text-terracotta-300 transition-colors">Politique de confidentialité</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <Phone className="h-4 w-4 mt-0.5 text-terracotta-300 shrink-0" />
                <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-terracotta-300 transition-colors">{COMPANY.phone}</a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="h-4 w-4 mt-0.5 text-terracotta-300 shrink-0" />
                <span>Oise (60) — Île-de-France & Picardie</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail className="h-4 w-4 mt-0.5 text-terracotta-300 shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-terracotta-300 transition-colors break-all">{COMPANY.email}</a>
              </li>
            </ul>
            <div className="flex flex-col gap-2 mt-5">
              <Link to="/devis" className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-terracotta-500 text-white hover:bg-terracotta-600 transition-colors font-medium text-sm">
                <FileText className="h-4 w-4" /> Demander un devis
              </Link>
              <Link to="/rappel" className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-md border border-vegetal-200/40 text-white hover:bg-vegetal-700 transition-colors font-medium text-sm">
                <PhoneCall className="h-4 w-4" /> Être rappelé
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-vegetal-700 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-vegetal-100/50">
          <p>© {new Date().getFullYear()} Carnier Toiture et Habitat — Tous droits réservés.</p>
          <div className="flex gap-4">
            <Link to="/mentions-legales" className="hover:text-terracotta-300 transition-colors">Mentions légales</Link>
            <Link to="/politique-confidentialite" className="hover:text-terracotta-300 transition-colors">Confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
